export function telCancel(e) {
  const trg = document.querySelector('.js-tel');

  if(!trg) { return false;}

  trg.addEventListener('click', function (e) {
    if (window.innerWidth >= 1024) {
      e.preventDefault();

    } else {
      return false;
    }
  });
}